import React from "react";
import { Alert, Container, Row, Col } from "react-bootstrap";

export default function IEDetected() {
  return (
    <Container>
      <Row className="mt-3">
        <Col>
          <Alert variant="danger">
            <Alert.Heading>Internet Explorer Detected</Alert.Heading>
            <div>
              Please use a modern browser such as Google Chrome, Mozilla Firefox
              or Microsoft Edge.
            </div>
          </Alert>
        </Col>
      </Row>
    </Container>
  );
}